import {ensureOk, fancyClient} from '@freckle/educator-entities/ts/openapi-clients'

export async function patchTeacher(
  teacherId: number,
  body: {mathStandardSetId?: string; language?: string}
): Promise<void> {
  await fancyClient
    .PATCH('/2/teachers/{TeacherR-TeacherId}', {
      params: {
        path: {
          'TeacherR-TeacherId': teacherId
        }
      },
      body
    })
    .then(ensureOk)
}
